import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

/**
 * Native HTML week input. Browser support is limited to Chromium; on other
 * engines the input falls back to a free-text field — values are still validated
 * by the form validator (`YYYY-Www`).
 */
export const WeekPickerField = ({ field, value, error, onChange }: FieldComponentProps) => {
  return (
    <FieldShell field={field} error={error}>
      <input
        id={field.title}
        type="week"
        className="form-input"
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </FieldShell>
  );
};
